const getters = {};

/**
 * Login 여부
 * @param {*} state
 * @returns {Array}
 */
getters.isLogin = (state) => state.isLogin;

// service list
getters.pointThumbnailList = (state) => state.pointThumbnailList;

// point list
getters.pointList = (state) => state.pointList;

/**
 * servic url
 * @param {*} state
 * @returns {Object}
 */
getters.serviceUrl = (state) => state.serviceUrl;

/**
 * service 정보
 * @param {*} state
 * @returns {Object}
 */
getters.serviceInfo = (state) => state.serviceInfo;

/**
 * Point 전환 레이어 URL
 * @param {*} state
 * @returns {Object}
 */
getters.exchangeLayerUrl = (state) => state.exchangeLayerUrl;

/**
 * Point 전환 아이프레임 여부
 * @param {*} state
 * @returns {Object}
 */
getters.isExchangeIframe = (state) => state.isExchangeIframe;

/**
 * 연락처 앞자리 리스트
 * @param {*} state
 * @returns {Array}
 */
getters.telNoFrontList = (state) => state.telNoFrontList;

export default {
  ...getters,
};
